import { render, staticRenderFns } from "./FormatObjectLocateTool.vue?vue&type=template&id=3644bf80&scoped=true&"
import script from "./FormatObjectLocateTool.vue?vue&type=script&lang=ts&"
export * from "./FormatObjectLocateTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatObjectLocateTool.vue?vue&type=style&index=0&id=3644bf80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644bf80",
  null
  
)

export default component.exports